/// <reference path="../../app.definition.ts" />

import { DiscussionComment } from "./discussionComment";
import { User } from "./user";
import { Document } from "./_adocument";

export class Discussion extends Document {

    discussionId;
    id;
    comments: DiscussionComment[] = [];
    title;
    name: String;
    createdDate: any;
    owner: User;
    subjectId;
    careItemId;
    currentComment; // used to hold comment in view
    documentViewers: any;
    presignedUrl: string;
    lastUpdatedTime: string;
    lastActionTime: string;
    subject: any;
    signStatus: number;
    signatureAssigned: boolean;
    rawDocSize: number;
    commentLoader: boolean;
    additionalProperties;

    deserialize(input: any) {
        input._id && (this.discussionId = input._id);
        input.discussionId && (this.discussionId = input.discussionId);
        input.id && (this.discussionId = input.id);
        input.subjectId && (this.subjectId = input.subjectId);
        input.id && (this.id = input.id);
        input.title && (this.name = input.title);
        input.activityDate && (this.createdDate = new Date(input.activityDate));
        input.owner && (this.owner = new User().deserialize(input.owner));
        input.documentViewers && (this.documentViewers = input.documentViewers);
        input.presignedUrl && (this.presignedUrl = input.presignedUrl);
        input.lastUpdatedTime && (this.lastUpdatedTime = input.lastUpdatedTime);
        input.lastActionTime && (this.lastActionTime = input.lastActionTime);
        input.signStatus && (this.signStatus = input.signStatus);
        this.signatureAssigned = input.signatureAssigned;
        this.signStatus = input.signStatus;
        input.rawDocSize && (this.rawDocSize = input.rawDocSize);
        input.careItemId && (this.careItemId = input.careItemId);

        if (!!input.comments) {
            for (var i = input.comments.length - 1; i >= 0; i--) {
                this.comments.push(new DiscussionComment().deserialize(input.comments[i]));
            }
        }

        super.deserialize(input);
        return this;
    }

    constructor() {
        super();
    }

    getDocumentType(): string {
        if (this.documentType == 'FOLIO' || !this.filename) return 'DISCUSSION';
        if (!!this.commentsCount) return 'BOTH';
        return 'DOCUMENT';
    }

}
